export default __webpack_public_path__ + "static/media/40266.bb692741.jpg";